import { useState } from 'react';
import * as S from './style';
/**
 * Components
 */
import ActionButtonIcon from "../Button/ActionButtonIcon";
/**
 * Icons 
*/
import { MagnifyingGlass } from "@phosphor-icons/react";
/**
 * hooks 
*/
import { useMultipleModal } from '../../hooks/useMultipleModal';
import apiRequest from '../../hooks/apiRequest';
/**
 * Interface
*/
import { IOrder } from 'Interfaces/IOrder';

interface IProps {
    label: string,
    placeholder: string,
    url: string,
    idSelect: any,
}

export default function Search({
    label,
    placeholder,
    url,
    idSelect
}: IProps) {

    const [searchTerm, setSearchTerm] = useState("");
    const [data, setData] = useState<IOrder[]>([]);

    const {
        isOpenModal,
        toggleModalVisibility,
        assignRef } = useMultipleModal();

    const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const value = event.target.value;
        setSearchTerm(value);
        if (value === "") {
            setSearchTerm("");
        }
    };

    const ActionSearch = async () => {
        console.log('pesquisar: ', searchTerm);
        if (searchTerm === '') {
            return;
        } else {
            const response = await apiRequest<{ data: IOrder[] }>(`${url}${searchTerm}`);
            if (response?.status === 200) {
                const dataRequest = response.data.data;
                if (dataRequest && dataRequest.length > 0) {
                    setData(dataRequest);
                }
                toggleModalVisibility("data-order");
            }
        }
    }

    // Adicionando produtos no input (Lente, armação e serviço)
    const handleButtonClick = (product: IOrder) => {
        setSearchTerm(product.number_ata);
        idSelect(product);
        toggleModalVisibility("data-order");
    };

    return (
        <S.Container>
            <S.Label>
                {label}
                <span>*</span>
            </S.Label>

            <S.ContentSearch>
                <S.Input
                    placeholder={placeholder}
                    onChange={handleInputChange}
                    value={searchTerm}
                />

                <ActionButtonIcon
                    icon={<MagnifyingGlass size={18} />}
                    actionButon={ActionSearch}
                />
            </S.ContentSearch>

            {isOpenModal("data-order") && (
                <S.PopMenu ref={(ref) => assignRef("data-order", ref)}>
                    {data.length > 0 ? (
                        data.map((val) => (
                            <S.ButtonMenu onClick={() => handleButtonClick(val)}>
                                {val.number_ata}
                            </S.ButtonMenu>
                        ))
                    )
                        : (
                            <span>Nenhum dado encontrado</span>
                        )}
                </S.PopMenu>
            )}
        </S.Container>
    )
}